export const db = {
  name: 'db',
  title: 'db.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-db.vue'),
  route: { name: 'db.index' },
  children: [
    {
      title: 'db.breadcrumb.database.index',
      route: { name: 'db.database.index' }
    },
    {
      title: 'db.breadcrumb.group.index',
      route: { name: 'db.group.index' }
    }
  ]
};
